import { render, staticRenderFns } from "./infoManagment.vue?vue&type=template&id=61a464bb"
import script from "./infoManagment.vue?vue&type=script&lang=js"
export * from "./infoManagment.vue?vue&type=script&lang=js"
import style0 from "./infoManagment.vue?vue&type=style&index=0&id=61a464bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports